import epsClient from 'enrollment-platform/api/eps.client'
import type { PaginatedHistoryResponseDto } from './dto/plan-override-history.dto'
import type {
  PaginatedPlanLevelHistoryResponseDto,
  PlanLevelHistoryQueryDto,
} from './dto/plan-level-history.dto'
import type { DeleteHistoryByFilterResponseDto } from './dto/common.dto'

const DEFAULT_RULE_BASE = '/api/v1/plan-benefit-override-rules'

export async function listOverrideHistory(
  ruleId: string,
  params: { page?: number; limit?: number },
  ruleBase = DEFAULT_RULE_BASE
): Promise<PaginatedHistoryResponseDto> {
  const { data } = await epsClient.get<PaginatedHistoryResponseDto>(
    `${ruleBase}/${ruleId}/history`,
    { params }
  )
  return data
}

export async function listPlanLevelHistory(
  params: PlanLevelHistoryQueryDto
): Promise<PaginatedPlanLevelHistoryResponseDto> {
  const { data } = await epsClient.get<PaginatedPlanLevelHistoryResponseDto>(
    '/api/v1/plan-benefit-override-rules/history',
    { params }
  )
  return data
}

export async function deleteHistoryEntry(
  ruleBase: string,
  logId: string
): Promise<void> {
  await epsClient.delete(`${ruleBase}/history/${logId}`)
}

export async function deleteHistoryByFilter(
  ruleBase: string,
  params?: Record<string, unknown>
): Promise<DeleteHistoryByFilterResponseDto> {
  const response = await epsClient.delete(`${ruleBase}/history`, { params })
  return response.data as DeleteHistoryByFilterResponseDto
}
